import { useApplicationCache } from '../../../../../../../../queries/useApplicationCache';

/**
 * Reads the list of rental unit GUIDs for a given property from the React Query application cache.
 */
export function useRentalUnitGuidsCache(propertyGuid: string): string[] {
    return useApplicationCache(d =>
        d.information?.properties?.items
            ?.find(p => p.guid === propertyGuid)
            ?.rentalUnits?.map(u => u.guid) ?? []
    ) ?? [];
}
